import { render } from "./incident.vue?vue&type=template&id=4707e087"
import script from "./incident.vue?vue&type=script&lang=js"
export * from "./incident.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__